import React, { FC, Fragment } from 'react';
import { TableCell, TableRow, Theme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActiveIndicator from 'components/users/shared/active-indicator/active-indicator.component';
import { LabClient } from 'models/client-directory';
import FormattedAddress from 'components/shared/address/formatted-address.component';
import { Organization } from 'models/organization';

type SupplierItemProps = {
    supplier: LabClient;
};
const SupplierItem: FC<SupplierItemProps> = ({ supplier }: SupplierItemProps) => {
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const lab = supplier.lab as Organization;

    const handleSupplierClick = (clientId: string) => {
        navigate(`/supplier-directory/${clientId}/supplier-details#contactDetails`);
    };

    return (
        <TableRow hover sx={{ cursor: 'pointer' }} onClick={() => handleSupplierClick(lab._id)}>
            <Fragment>
                <TableCell>{lab.name}</TableCell>
                <TableCell>
                    <FormattedAddress address={lab.contact.address} />
                </TableCell>
                {!isMobile && (
                    <TableCell sx={{ width: 10 }} align="center">
                        <ActiveIndicator isActive={lab.active || false} />
                    </TableCell>
                )}
            </Fragment>
        </TableRow>
    );
};

export default SupplierItem;
